import { render } from "./Sheet.vue?vue&type=template&id=67746210&scoped=true&ts=true"
import script from "./Sheet.vue?vue&type=script&lang=ts"
export * from "./Sheet.vue?vue&type=script&lang=ts"

import "./Sheet.vue?vue&type=style&index=0&id=67746210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67746210"]])

export default __exports__